// import { Env } from 'skyflow-js';
// import { GetSkyFlowToken } from './common.services';
// import {
//     FileRenderElement,
//     useMakeSkyflowStyles,
//     useRenderFile, SkyflowElements,
//     useRevealContainer,
// } from 'skyflow-react-js'
import { Placeholder } from 'rsuite';
import React, { useEffect, useState } from 'react';
import { GetSkyFlowData } from '../admin/services/common.service';

// function ShowImage(props) {
//     const elementID = props.elementID || `imageElement-${props.skyflowID}`;
//     const [showLoader, setShowLoader] = useState(true);
//     const revealContainer = useRevealContainer();
//     const fileElement = useRenderFile(elementID);
//     const useStyles = useMakeSkyflowStyles({
//         inputStyles: {
//             base: {
//                 width: '200px',
//                 height: '200px',
//                 objectFit: 'cover',
//                 borderRadius: '8px',
//                 ...(props.style || {}),
//             },
//         },

//     });
//     const classes = useStyles();
//     useEffect(() => {
//         if (fileElement) {
//             fileElement?.renderFile().then(() => {
//                 setShowLoader(false);
//             }).catch((err) => {
//                 console.error("Error in image loading", err);
//             });
//         }
//     }, [fileElement]);

//     return (
//         <div style={{ position: 'relative' }}>
//             {
//                 showLoader ?
//                     <div style={{ ...props.loaderContainerStyle, position: 'absolute', zIndex: 2, top: 0, left: 0, height: '100%', width: "100%" }}>
//                         <Placeholder.Graph active className='admin-placeholder' style={{ borderRadius: '0' }} />
//                     </div>
//                     : null
//             }
//             <div style={{ position: 'relative', zIndex: 1 }}>
//                 <FileRenderElement
//                     container={revealContainer}
//                     id={elementID}
//                     skyflowID={props.skyflowID}
//                     classes={classes}
//                     table={props.table}
//                     column={props.column}
//                     altText=''
//                     loader={<div style={{ display: "none" }} />}
//                 />
//             </div>
//         </div>
//     );
// }

export default function ShowSkyflowImage(props) {
    const [imageUrl, setImageUrl] = useState(null);
    const [showLoader, setShowLoader] = useState(true);

    const imageStyles = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: 8,
        position: 'relative',
        zIndex: 1,
        ...props.style,
    };

    useEffect(() => {
        async function fetchImage() {
            try {
                const response = await GetSkyFlowData({
                    skyflow_id: props.skyflowID,
                    table: props.table,
                    columnName: props.column,
                });
                console.log(response,'response');
                
                const url = response?.data?.[props.column];
                if (url) setImageUrl(url);
            } finally {
                setShowLoader(false);
            }
        }

        fetchImage();
    }, [props.skyflowID, props.table, props.column]);
    // const config = {
    //     vaultID: 'jdad3d2122d7453888a96ec7d1975091',
    //     vaultURL: 'https://a370a9658141.vault.skyflowapis-preview.com',
    //     env: Env.PROD,
    //     getBearerToken: () => {
    //         return GetSkyFlowToken().then((response) => {
    //             return response.data.accessToken;
    //         });
    //     },
    // };
    return (
        <div style={{ position: 'relative', width: props.style?.width || '200px', height: props.style?.height || '200px', ...props.containerStyle }}>
            {showLoader && (
                <div
                    style={{
                        ...props.loaderContainerStyle,
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <Placeholder.Graph active className='admin-placeholder' style={{ borderRadius: imageStyles.borderRadius, width: '100%',height: '100%', }} />
                </div>
            )}

            {imageUrl && (
                <img
                    src={imageUrl}
                    alt={props.altText || 'Image'}
                    style={imageStyles}
                    onLoad={() => setShowLoader(false)}
                    onError={() => setShowLoader(false)}
                />
            )}
        </div>
        // <SkyflowElements config={config}>
        //     <ShowImage {...props} />
        // </SkyflowElements>
    )
}